import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CompanyFormHeader from "@/components/Companies/CompanyFormHeader";
import PageHeader from "@/components/Common/PageHeader";
import { default as CompanyFormComponent } from "@/components/Companies/CompanyComponents/Form";
import useToastStore from "@/components/Common/Toast/toastStore";

const CompanyForm = ({ hideHeader, companyId: propCompanyId }) => {
  const navigate = useNavigate();
  const { id: paramId } = useParams();
  const { showToast } = useToastStore;
  // Resolve the companyId from the prop or URL parameter.
  const companyId = propCompanyId || paramId;

  const handleBack = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    e.stopPropagation(); // Stop event bubbling
    navigate(-1);
  };

  // if (isCompanyLoading) {
  //   return <Loader />;
  // }

  return (
    <div className="min-h-screen bg-muted/50 p-8 relative">
      <div className="max-w-[90%] mx-auto">
        {!hideHeader && <CompanyFormHeader isEdit={!!companyId} />}

        {!companyId && (
          <div className="mb-6">
            <PageHeader
              navigationText="Back to Companies"
              navigateTo={handleBack}
            />
          </div>
        )}

        <div
          className={`bg-card ${companyId ? "" : "rounded-xl shadow-sm border border-border/50"} overflow-visible w-full`}
        >
          <div className="p-10">
            <CompanyFormComponent hideHeader={true} companyId={companyId} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyForm;
